var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container-fluid"},[_c('base-info'),_c('Row',{attrs:{"gutter":24}},[_c('Col',{attrs:{"lg":{ span: 16 }}},[_c('leftchart')],1),_c('Col',{attrs:{"lg":{ span: 8 }}},[_c('rightchart')],1)],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }